module.exports = __webpack_public_path__ + "img/icon-use.bd2dd63.png";